import React, { useState, useEffect, useCallback, useRef } from "react";
import { NavLink, Outlet, useLocation, useMatch } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Tabs,
  DialogContent,
  Dialog,
  OutlinedInput,
  InputAdornment,
  TextField,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Avatar,
  Link,
  Alert,
  AlertTitle,
} from "@mui/material";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { Scrollbar } from "../../components/scrollbar";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

import Download01Icon from "@untitled-ui/icons-react/build/esm/Download01";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import Upload01Icon from "@untitled-ui/icons-react/build/esm/Upload01";
import SearchMdIcon from "@untitled-ui/icons-react/build/esm/SearchMd";
import { FileDropzone } from "../../components/file-dropzone";

type User = {
  biografia: string; // Biografia do parlamentar
  cpf: string; // CPF do parlamentar
  email: string; // Email do parlamentar
  endereco: string; // Endereço do parlamentar
  enderecoGab: string; // Endereço do gabinete
  funcaoPartidaria: string; // Função partidária (ex.: vereador)
  imageP: string; // URL da imagem do perfil
  legislatura: string; // Informação sobre a legislatura
  nome: string; // Nome do parlamentar
  parlamentarEstado: string; // Estado do parlamentar (ex.: ativo)
  partido: string; // Partido ao qual o parlamentar pertence
  telefone: string; // Telefone do parlamentar
  telefoneGab: string; // Telefone do gabinete
  nomeParlamentar: string; // Apelido do parlamentar
};

export function Entidades() {
  const [entidades, setEntidades] = useState([] as User[]);
  const [open, setOpen] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [searchLegislatura, setSearchLegislatura] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [filteredData, setFilteredData] = useState([] as User[]);

  const navigate = useNavigate();

  const filtersOptions = [
    {
      label: "Ativo",
      value: "ativo",
    },
    {
      label: "Inativo",
      value: "nao-ativo",
    },
  ];

  const legislaturaOptions = [
    {
      label: "Legislatura (2025) - (2028)",
      value: "Legislatura (2025) - (2028)",
    },
    {
      label: "Legislatura (2021) - (2024)",
      value: "Legislatura (2021) - (2024)",
    },
    {
      label: "Legislatura (2016) - (2020)",
      value: "Legislatura (2016) - (2020)",
    },
  ];

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(db, "users", `belacruz@eleg`, "parlamentares");

    getDocs(ordersRef)
      .then((querySnapshot) => {
        const parsedData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          // Cria um objeto com as propriedades e seus respectivos valores
          const obj = {
            id: doc.id,
            ...data,
          };

          return obj;
        });

        //@ts-ignore
        setEntidades(parsedData);
      })
      .catch((error) => {
        console.log("Erro ao recuperar dados da subcoleção:", error);
      });
  }, []);

  useEffect(() => {
    if (searchStatus === "") {
      setSearchStatus(filtersOptions[0].value);
    }
    if (searchLegislatura === "") {
      setSearchLegislatura(legislaturaOptions[0].value);
    }

    const filtered = entidades.filter((item) => {
      const isNameMatch =
        !searchName ||
        item.nome?.toLowerCase().includes(searchName.toLowerCase());
      const isLegislaturaMatch =
        !searchLegislatura || item.legislatura?.includes(searchLegislatura);
      const isStatusMatch =
        !searchStatus || item.parlamentarEstado === searchStatus;

      return isNameMatch && isLegislaturaMatch && isStatusMatch;
    });

    setFilteredData(filtered);
  }, [entidades, searchName, searchLegislatura, searchStatus]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        pb: 3,
      }}
    >
      <Dialog open={open} fullWidth maxWidth="md">
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <Typography variant="h6"></Typography>
          <IconButton
            color="inherit"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>
        <DialogContent
          sx={{
            width: 800,
            height: 600,
          }}
        ></DialogContent>
      </Dialog>

      <Container maxWidth="xl">
        {/* Banner da API Oficial */}
        {/* <Stack
          alignItems="center"
          direction={{
            xs: "column",
            md: "row",
          }}
          spacing={4}
          sx={{
            backgroundColor: "#1976d2",
            borderRadius: 2.5,
            p: 4,
            mb: 4,
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              color="#fff"
              sx={{
                fontFamily: "Saira, sans-serif",
                fontWeight: 600,
                fontSize: 20,
              }}
            >
              🔗 API Oficial Disponível
            </Typography>
            <Typography
              color="#fff"
              sx={{
                mt: 1,
                fontFamily: "Saira, sans-serif",
                fontSize: 16,
              }}
            >
              O sistema possui uma API REST completa para integração com outros
              sistemas.
            </Typography>
            <Typography
              color="#fff"
              variant="body2"
              sx={{ mt: 1, fontFamily: "Saira, sans-serif", opacity: 0.9 }}
            >
              Documentação completa disponível em:
              https://eleg-api-b277f043fab9.herokuapp.com/api-docs/
            </Typography>
          </Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#fff",
              color: "#1976d2",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => {
              window.open(
                "https://eleg-api-b277f043fab9.herokuapp.com/api-docs/",
                "_blank"
              );
            }}
          >
            Ver Documentação
          </Button>
        </Stack> */}

        <Stack spacing={4}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1}>
              <Typography variant="h4">Parlamentares</Typography>
            </Stack>
          </Stack>

          <Card>
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              spacing={3}
              sx={{ p: 3 }}
            >
              <Box component="form" sx={{ flexGrow: 1 }}>
                <OutlinedInput
                  defaultValue=""
                  fullWidth
                  placeholder="Procure por nome..."
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <SvgIcon>
                        <SearchMdIcon />
                      </SvgIcon>
                    </InputAdornment>
                  }
                />
              </Box>

              <TextField
                label="Legislatura"
                name="sort"
                select
                size="medium"
                onChange={(e) => setSearchLegislatura(e.target.value)}
                SelectProps={{ native: true }}
              >
                {legislaturaOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>

              <TextField
                label="Status"
                name="sort"
                select
                size="small"
                onChange={(e) => setSearchStatus(e.target.value)}
                SelectProps={{ native: true }}
              >
                {filtersOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Stack>

            <Box sx={{ position: "relative" }}>
              <Scrollbar>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox checked={false} />
                      </TableCell>
                      <TableCell>Parlamentar</TableCell>
                      <TableCell>Endereço</TableCell>
                      <TableCell align="left">Legislatura</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData !== undefined &&
                      filteredData.map((item) => {
                        return (
                          <TableRow
                            hover
                            //@ts-ignore
                            key={item.id}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox checked={false} />
                            </TableCell>
                            <TableCell>
                              <Stack
                                alignItems="center"
                                direction="row"
                                spacing={1}
                              >
                                <Avatar
                                  //@ts-ignore
                                  src={item.imageP}
                                  sx={{
                                    height: 42,
                                    width: 42,
                                  }}
                                ></Avatar>
                                <div>
                                  <Typography
                                    color="inherit"
                                    variant="subtitle2"
                                  >
                                    {item.nomeParlamentar !== ""
                                      ? item.nomeParlamentar
                                      : item.nome}
                                  </Typography>
                                  <Typography
                                    color="text.secondary"
                                    variant="body2"
                                  >
                                    {/*@ts-ignore*/}
                                    {item.cpf}
                                  </Typography>
                                </div>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {item.endereco}
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {item.legislatura}
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                onClick={() => {
                                  //@ts-ignore
                                  navigate(`/parlamentar/${item.id}`);
                                }}
                              >
                                <SvgIcon>
                                  <Edit02Icon />
                                </SvgIcon>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
